import { AwrDomainContext, AwrAccountContextValue } from '../model/AwrContext';
import { AWRContextResponse } from './AWRContextResponse';
export class AWRContextUtils {
    static getContextFromDomainValue(awrDomainContext: AwrDomainContext<any>): AWRContextResponse {
        let response: AWRContextResponse = new AWRContextResponse();
        let contextValue = awrDomainContext;
        if (contextValue instanceof AwrAccountContextValue) {
            response.accountNumber = contextValue.accountNumber;
            response.timePeriod = contextValue.timPeriod;
            response.goToTab = contextValue.goToTab;
            response.awrAccount = contextValue.awrAccount;
        } else {
            response.accountNumber = '';
            response.timePeriod = '';
            response.goToTab = '';
            response.awrAccount = '';
        }
        return response;
    }
}
